import React, { useId } from "react";

// Logo #GHEXPERIENCE em SVG inline, glifo a glifo, para a abertura animar cada letra
// (ordem de leitura; o "X" da marca é um grupo próprio de quatro traços). Mesmo desenho de logo-ghexperience.svg.
const GLYPHS = [
  {
    key: "hash",
    fill: "#ff6700",
    d: "M505.11 550.76L591.27 550.76L590.17 557.19L504.01 557.19L505.11 550.76M520.13 522.80L595.92 522.80L594.87 529.24L519.08 529.24L520.13 522.80M552.22 499.85L558.76 499.85L545.56 580.16L539.02 580.16L552.22 499.85M580.45 499.85L586.99 499.85L573.79 580.16L567.30 580.16L580.45 499.85"
  },
  {
    key: "g",
    fill: "#f7f7f7",
    d: "M657.74 518.07C655.97 516.02 653.83 514.44 651.31 513.35C648.80 512.26 645.93 511.71 642.71 511.71C638.35 511.71 634.49 512.82 631.12 515.01C627.75 517.21 625.11 520.43 623.19 524.67C621.26 528.90 620.31 534.00 620.31 539.94C620.31 545.89 621.25 551.06 623.13 555.31C625.01 559.57 627.67 562.78 631.10 564.99C634.52 567.19 638.50 568.29 643.04 568.29C647.11 568.29 650.65 567.50 653.66 565.93C656.68 564.37 659.00 562.10 660.62 559.17C662.24 556.22 663.06 552.84 663.06 549.00L666.33 549.50L644.49 549.50L644.49 538.13L677.04 538.13L677.04 547.78C677.04 554.51 675.59 560.41 672.69 565.47C669.78 570.54 665.76 574.43 660.62 577.17C655.48 579.91 649.60 581.28 642.99 581.28C635.62 581.28 629.14 579.60 623.55 576.26C617.95 572.92 613.60 568.13 610.49 561.92C607.38 555.72 605.83 548.42 605.83 540.08C605.83 531.73 607.42 524.27 610.60 518.05C613.78 511.83 618.14 507.08 623.69 503.75C629.24 500.42 635.50 498.76 642.50 498.76C648.37 498.76 653.73 499.89 658.57 502.14C663.42 504.39 667.40 507.54 670.52 511.56C673.64 515.60 675.61 520.24 676.43 525.49L661.67 525.49C660.82 522.61 659.50 520.14 657.73 518.08L657.74 518.07"
  },
  {
    key: "h",
    fill: "#f7f7f7",
    d: "M685.63 499.85L700.04 499.85L700.04 533.95L737.42 533.95L737.42 499.85L751.89 499.85L751.89 580.16L737.42 580.16L737.42 546.00L700.04 546.00L700.04 580.16L685.63 580.16L685.63 499.85"
  },
  {
    key: "e1",
    fill: "#ff6700",
    d: "M771.91 499.85L820.57 499.85L820.57 506.88L780.05 506.88L780.05 536.45L817.99 536.45L817.99 543.43L780.05 543.43L780.05 573.05L821.25 573.05L821.25 580.16L771.91 580.16L771.91 499.85"
  },
  {
    key: "x",
    fill: "#ff6700",
    d: "M865.03 542.34L837.84 580.16L827.40 580.16L856.29 540.61C856.55 540.25 856.55 539.76 856.29 539.40L827.40 499.85L837.96 499.85L865.03 537.66C866.04 539.07 866.02 540.95 865.03 542.34"
  },
  {
    key: "x",
    fill: "#ff6700",
    d: "M880.94 548.76L858.37 580.16L847.94 580.16L873.65 544.96C875.80 542.01 875.80 538.00 873.65 535.06L847.94 499.86L858.50 499.86L880.97 531.24C884.72 536.49 884.72 543.54 880.96 548.78L880.94 548.76"
  },
  {
    key: "x",
    fill: "#ff6700",
    d: "M918.39 499.85L891.66 536.46C891.14 533.50 889.98 530.63 888.16 528.06L887.90 527.71L907.85 499.85L918.40 499.85L918.39 499.85"
  },
  {
    key: "x",
    fill: "#ff6700",
    d: "M918.39 580.16L907.96 580.16L887.88 552.24L888.12 551.92C889.96 549.36 891.13 546.49 891.65 543.51L918.39 580.16"
  },
  {
    key: "p",
    fill: "#ff6700",
    d: "M926.05 499.85L955.03 499.85C961.24 499.85 966.52 500.93 970.87 503.09C975.22 505.26 978.48 508.21 980.67 511.94C982.85 515.68 983.94 519.96 983.94 524.80C983.94 529.65 982.85 533.85 980.67 537.61C978.49 541.39 975.23 544.36 970.91 546.54C966.57 548.72 961.33 549.82 955.16 549.82L932.74 549.82L932.74 542.71L954.79 542.71C959.32 542.71 963.13 541.95 966.22 540.41C969.30 538.88 971.59 536.75 973.08 534.02C974.56 531.31 975.31 528.23 975.31 524.79C975.31 521.35 974.56 518.12 973.08 515.45C971.59 512.76 969.27 510.68 966.15 509.15C963.03 507.64 959.19 506.87 954.67 506.87L934.76 506.87L934.76 580.13L926.05 580.13L926.05 499.82L926.05 499.85"
  },
  {
    key: "e2",
    fill: "#ff6700",
    d: "M993.26 499.85L1041.92 499.85L1041.92 506.88L1001.40 506.88L1001.40 536.45L1039.34 536.45L1039.34 543.43L1001.40 543.43L1001.40 573.05L1042.60 573.05L1042.60 580.16L993.26 580.16L993.26 499.85"
  },
  {
    key: "r",
    fill: "#ff6700",
    d: "M1055.47 499.85L1082.58 499.85C1088.46 499.85 1093.44 500.86 1097.49 502.88C1101.54 504.89 1104.58 507.73 1106.60 511.39C1108.62 515.04 1109.64 519.27 1109.64 524.03C1109.64 528.79 1108.63 532.93 1106.60 536.53C1104.58 540.13 1101.54 542.94 1097.49 544.96C1093.44 546.98 1088.52 547.99 1082.71 547.99L1059.90 547.99L1059.90 540.77L1082.36 540.77C1086.65 540.77 1090.22 540.09 1093.08 538.71C1095.95 537.35 1098.07 535.43 1099.47 532.95C1100.86 530.46 1101.55 527.49 1101.55 524.01C1101.55 520.54 1100.86 517.45 1099.47 514.89C1098.07 512.33 1095.93 510.35 1093.04 508.96C1090.15 507.57 1086.55 506.87 1082.24 506.87L1063.61 506.87L1063.61 580.13L1055.47 580.13L1055.47 499.82L1055.47 499.85M1113.06 580.14L1103.54 580.14L1083.37 543.92L1092.66 543.92L1113.06 580.14"
  },
  {
    key: "i",
    fill: "#ff6700",
    d: "M1130.22 580.14L1122.08 580.14L1122.08 499.83L1130.22 499.83L1130.22 580.14"
  },
  {
    key: "e3",
    fill: "#ff6700",
    d: "M1146.24 499.85L1194.90 499.85L1194.90 506.88L1154.38 506.88L1154.38 536.45L1192.32 536.45L1192.32 543.43L1154.38 543.43L1154.38 573.05L1195.58 573.05L1195.58 580.16L1146.24 580.16L1146.24 499.85"
  },
  {
    key: "n",
    fill: "#ff6700",
    d: "M1273.31 580.14L1265.53 580.14L1217.28 513.92L1216.60 513.92L1216.60 580.14L1208.45 580.14L1208.45 499.83L1216.36 499.83L1264.61 566.17L1265.31 566.17L1265.31 499.83L1273.33 499.83L1273.33 580.14L1273.31 580.14"
  },
  {
    key: "c",
    fill: "#ff6700",
    d: "M1341.99 515.29C1339.66 512.42 1336.75 510.19 1333.25 508.58C1329.76 506.97 1325.94 506.16 1321.82 506.16C1316.56 506.16 1311.78 507.47 1307.53 510.10C1303.27 512.74 1299.89 516.60 1297.38 521.70C1294.87 526.80 1293.63 532.91 1293.63 540.00C1293.63 547.09 1294.87 553.24 1297.36 558.33C1299.84 563.41 1303.22 567.26 1307.50 569.89C1311.78 572.52 1316.56 573.83 1321.82 573.83C1325.95 573.83 1329.74 573.03 1333.22 571.42C1336.70 569.81 1339.62 567.57 1341.96 564.71C1344.31 561.84 1345.86 558.61 1346.63 555.03L1354.77 555.03C1353.85 559.98 1351.90 564.46 1348.92 568.47C1345.95 572.48 1342.11 575.62 1337.46 577.87C1332.80 580.12 1327.59 581.25 1321.82 581.25C1314.83 581.25 1308.61 579.54 1303.14 576.15C1297.67 572.75 1293.41 567.93 1290.36 561.71C1287.31 555.48 1285.78 548.23 1285.78 540.00C1285.78 531.76 1287.31 524.46 1290.36 518.23C1293.41 512.00 1297.67 507.20 1303.14 503.82C1308.61 500.44 1314.83 498.74 1321.82 498.74C1327.55 498.74 1332.76 499.88 1337.44 502.13C1342.11 504.38 1345.95 507.50 1348.92 511.47C1351.90 515.44 1353.85 519.98 1354.77 525.08L1346.63 525.08C1345.86 521.42 1344.32 518.15 1341.99 515.29"
  },
  {
    key: "e4",
    fill: "#ff6700",
    d: "M1366.66 499.85L1415.32 499.85L1415.32 506.88L1374.80 506.88L1374.80 536.45L1412.74 536.45L1412.74 543.43L1374.80 543.43L1374.80 573.05L1416.00 573.05L1416.00 580.16L1366.66 580.16L1366.66 499.85"
  }
];

// sheen: uma faixa de luz recortada pelo próprio desenho das letras (anima por CSS, só transform/opacity).
function GhxpLogo({ className = "", title = "#GHEXPERIENCE", sheen = false }) {
  const id = useId().replace(/:/g, "");
  let order = -1;
  let lastKey = null;
  return (
    <svg className={`ghxpLogo ${className}`} viewBox="504.01 498.74 911.99 82.53" role="img" aria-label={title} focusable="false">
      {sheen && (
        <defs>
          <linearGradient id={`${id}-grad`} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#f7f7f7" stopOpacity="0" />
            <stop offset="0.5" stopColor="#f7f7f7" stopOpacity="0.9" />
            <stop offset="1" stopColor="#f7f7f7" stopOpacity="0" />
          </linearGradient>
          <clipPath id={`${id}-clip`}>
            {GLYPHS.map((glyph, i) => (
              <path key={i} d={glyph.d} />
            ))}
          </clipPath>
        </defs>
      )}
      {GLYPHS.map((glyph, i) => {
        if (glyph.key !== lastKey) order += 1;
        lastKey = glyph.key;
        return (
          <path
            key={i}
            className={`ghxpLogo__glyph ${glyph.key === "x" ? "ghxpLogo__glyph--x" : ""}`}
            style={{ "--i": order }}
            fill={glyph.fill}
            d={glyph.d}
          />
        );
      })}
      {sheen && (
        // O recorte fica no grupo (fixo); só a faixa se move, senão a silhueta das letras viajaria junto.
        <g clipPath={`url(#${id}-clip)`}>
          <rect className="ghxpLogo__sheen" x="504" y="480" width="220" height="120" fill={`url(#${id}-grad)`} />
        </g>
      )}
    </svg>
  );
}

export default GhxpLogo;
